module.exports = __webpack_public_path__ + "img/station_with_number_and_arrow.ff82124e.png";